import * as React from 'react';
import styled from "styled-components";
import whiteTrashBin from "../../images/whiteTrashBin.svg"
import {useState, useEffect} from "react";
import { Image } from 'antd';
import ImageDownloadable from "../ImageElements/ImageDownloadable";

const TrashBinContainer = styled.div`
  cursor: pointer;
  position: absolute;
  border-radius: 0.25em;
  opacity: 50%;
  background-color: black;
  padding-left: 4px;
  top: 4px;
  right: 4px;
  height: 24px;
  width : 24px;
`

type DeletableImageProps = {
  id: string | File,
  type: string,
  isOnServer: boolean,
  fileBlob?: Blob,
  deleteHandle: (id: string) => void
}

export const DeletableImage = ({id, type, isOnServer, fileBlob, deleteHandle}: DeletableImageProps) => {
  const [picture, setPicture] = useState<string | null | ArrayBuffer>(null);
  const reader = new FileReader();

  reader.onloadend = function () {
    setPicture(reader.result);
  }

  useEffect(()=> {
    if (!isOnServer && fileBlob instanceof File) {
      if (fileBlob) {
        reader.readAsDataURL(fileBlob);
      }
    }
  }, [fileBlob])

  return(
      <div className="position-relative" style={{height:'126px', width: '156px', marginRight: '12px', marginBottom: '12px'}}>
         {(isOnServer) ?
            <ImageDownloadable id={String(id)} type={type} style={{objectFit : "cover", width:"156px", height: '126px'}} key={'d'+id}/>
          :
            <Image src={String(picture)} style={{objectFit : "cover", width:"156px", height: '126px'}} key={'i'+id}/>}
        <TrashBinContainer>
          <img src={whiteTrashBin} onClick={() => deleteHandle(String(id))} style={{width: '16px', height: '16px'}}/>
        </TrashBinContainer>
      </div>
  )
}